
<div class="val-vue-principale val-flex-conteneur val-flex-colonne">
	<div class="val-vue-principale-entete">
		<val-bandeau-application #bandeauApplication
								 srcLogo="assets/val_ammon_efacture_logo_48.png"
								 srcLogoEditeur="assets/editor_logo_48.png"
								 [titre]="barreNavigation.navigationItemEnCours && barreNavigation.navigationItemEnCours.libelle ? barreNavigation.navigationItemEnCours.libelle : ''"
								 [dicoTitre]="barreNavigation.navigationItemEnCours?.dico"
								 [nomUtilisateur]="loginUtilisateur()"
								 ouvert="true"
								 rechercheOuverte="true"
								 choixLangue="true"
								 [navigationMesPreferences]="navigationMesPreferences"
								 [navigationMesAbonnements]="navigationMesAbonnements"
								 [barreNavigation]="barreNavigation">
		</val-bandeau-application>
	</div>
	<div class="val-vue-principale-page val-flex-1 val-flex-conteneur val-couleur-fond">
		<div class="val-vue-principale-barre-navigation">
			<val-barre-navigation #barreNavigation
								  [navigationItems]="navigationItems"
								  [largeur]="250"
								  ouvert="true"
								  [urlApiManifest]="RetournerUrlApiManifest()">
			</val-barre-navigation>
		</div>
		<div class="val-vue-principale-contenu val-flex-1 val-couleur-fond-page">
			@if (estInitialise) {
			<router-outlet name="page"></router-outlet>
			}
		</div>
	</div>
</div>
